import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiPhone } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import ScrollReveal from "./ScrollReveal.jsx";

export default function HomePreviewCta() {
  return (
    <section id="preview-contact" className="bg-[linear-gradient(180deg,#ffffff_0%,#FDFBF7_100%)] px-4 py-20 text-white sm:px-6">
      <ScrollReveal className="mx-auto max-w-6xl overflow-hidden rounded-[32px] border border-white/15 bg-[linear-gradient(135deg,#0A3D3A_0%,#0B2822_72%,#172e14_100%)] p-6 shadow-hp-dark sm:p-8 lg:p-12">
        <div className="grid gap-8 lg:grid-cols-[1fr_0.82fr] lg:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-zoom-goldSoft">Start Planning</p>
            <h2 className="font-display mt-4 text-3xl font-bold tracking-tight sm:text-[44px] sm:leading-tight">
              Ready to plan your next celebration?
            </h2>
            <p className="mt-4 max-w-2xl text-base font-normal leading-8 text-white/84">
              Get quick WhatsApp support from DecorZoom for banquet discovery, decoration themes, return gifts, activities, and complete celebration support.
            </p>
          </div>

          <div className="grid gap-3">
            <a
              href="https://wa.me/918377982191"
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-semibold text-white shadow-hp-sm transition hover:-translate-y-0.5 hover:brightness-95"
            >
              <FaWhatsapp aria-hidden="true" /> WhatsApp Now
            </a>
            <a
              href="tel:+918377982191"
              className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-semibold text-zoom-emeraldDeep shadow-hp-sm transition hover:-translate-y-0.5 hover:bg-zoom-goldSoft/40"
            >
              <FiPhone aria-hidden="true" /> Call Now
            </a>
            <Link
              to="/banquets"
              className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-full border border-zoom-goldSoft/60 bg-zoom-goldSoft px-5 py-3 text-sm font-semibold text-zoom-emeraldDeep shadow-hp-gold transition hover:-translate-y-0.5 hover:bg-white"
            >
              Search Banquet <FiArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>
      </ScrollReveal>
    </section>
  );
}
